import { InvalidEntityData, OrderItemDto } from "@deliverr/replenishment-client";
import { SPThunkAction } from "common/ReduxUtils";
import { getUnifiedProducts } from "common/wholesale-common/getUnifiedProducts";
import { keys, uniq } from "lodash";
import { mapOrderItemsToSelectedProducts } from "./utils/mapOrderItemsToSelectedProducts";
import { transferBulkAddProduct } from "transfers/create/actions";
import { getReplenishmentUnifiedInventory } from "../replenishment/warehouse-selection/actions/getReplenishmentUnifiedInventory";
import { updateOrderItemsLotNumber } from "./updateOrderItemsLotNumber";
import { doesOrderItemNotRequireInventory, getDskuFromInvalidEntity } from "./utils/invalidOrderItemUtils";

export const loadProductsAndInventoryForTransfer =
  (orderItems: OrderItemDto[], invalidEntities?: InvalidEntityData[]): SPThunkAction<Promise<void>> =>
  async (dispatch) => {
    // Partition order items into ones that require inventory and ones that don't
    const orderItemsNotRequiringInventory: OrderItemDto[] = [];
    const orderItemsRequiringInventory: OrderItemDto[] = [];

    const invalidEntitiesMap = new Map<string, InvalidEntityData>();
    invalidEntities?.forEach((invalidEntity) => {
      invalidEntitiesMap.set(invalidEntity.invalidEntityId, invalidEntity);
    });

    orderItems.forEach((orderItem) => {
      const invalidEntity = orderItem.lineItemId ? invalidEntitiesMap.get(orderItem.lineItemId) : undefined;
      const dsku = getDskuFromInvalidEntity(invalidEntity);
      if (doesOrderItemNotRequireInventory(orderItem, invalidEntities)) {
        orderItemsNotRequiringInventory.push(orderItem);
      } else {
        orderItemsRequiringInventory.push({
          ...orderItem,
          packOf: dsku ?? orderItem.packOf,
          dsku: dsku ?? orderItem.dsku,
        });
      }
    });

    const productDskusToCallProductFor = uniq(orderItemsRequiringInventory.map(({ packOf }) => packOf));

    const productCollection = await dispatch(getUnifiedProducts(productDskusToCallProductFor));

    // TODO - Handle units sold last 30 days

    // Map all order items, but provide the partitioned list of items not requiring inventory
    const selectedProducts = mapOrderItemsToSelectedProducts(
      [...orderItemsRequiringInventory, ...orderItemsNotRequiringInventory],
      productCollection,
      orderItemsNotRequiringInventory,
      invalidEntities
    );

    dispatch(transferBulkAddProduct(selectedProducts));

    const selectedDskus = keys(selectedProducts);

    // Update lot numbers for items
    dispatch(updateOrderItemsLotNumber(orderItems));

    dispatch(getReplenishmentUnifiedInventory(selectedDskus));
  };
